import { useState } from "react";

const useSort = (sortBy, sortOrder) => {
  const [state, setState] = useState({ sortBy, sortOrder });

  const onSortChange = data => {
    setState(data);
  };

  return { sortBy: state.sortBy, sortOrder: state.sortOrder, onSortChange };
};

export default useSort;
